var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, Card, CardContent, DialogActions, Button } from "@mui/material";
import { WorkflowAttachmentType } from "../models";
import "./workflow-step-help.scss";
import { useEffect, useState } from "react";
import { workflowAttachmentApi } from "../workflow-attachment-api";
import WorkflowStepHelpImage from "./workflow-step-help-image";
export default function WorkflowStepHelp(props) {
    var _this = this;
    var _a = useState(""), videoUrl = _a[0], setVideoUrl = _a[1];
    var _b = useState([]), attachments = _b[0], setAttachments = _b[1];
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var instructions, attachments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.step.instructionsFileId) {
                            setVideoUrl("");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, workflowAttachmentApi.getAttachmentByType(props.step.caseTypeId, props.step.id, WorkflowAttachmentType.Instructions)];
                    case 1:
                        instructions = _a.sent();
                        setVideoUrl(instructions.url);
                        return [4 /*yield*/, workflowAttachmentApi.getAllAttachments(props.step.caseTypeId, props.step.id)];
                    case 2:
                        attachments = _a.sent();
                        setAttachments(attachments);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [props.step]);
    function renderDescription() {
        return (_jsxs("div", __assign({ className: "workflow-step-help__section" }, { children: [_jsx("h3", { children: "Description" }, void 0), _jsx("p", { children: props.step.description }, void 0)] }), void 0));
    }
    function renderVideo() {
        if (!videoUrl)
            return null;
        return (_jsxs("div", __assign({ className: "workflow-step-help__section" }, { children: [_jsx("h3", { children: "Video instructions" }, void 0), _jsx("div", __assign({ className: "flex-col align-center" }, { children: _jsx("video", { src: videoUrl, controls: true, autoPlay: false, height: 300 }, void 0) }), void 0)] }), void 0));
    }
    function renderPhotos() {
        if (attachments.length === 0)
            return null;
        return (_jsxs("div", __assign({ className: "workflow-step-help__section" }, { children: [_jsx("h3", { children: "Sample photos" }, void 0), _jsx("div", __assign({ className: "workflow-step-attachments-list" }, { children: attachments.map(function (a, i) { return _jsx(WorkflowStepHelpImage, { url: a.url }, i); }) }), void 0)] }), void 0));
    }
    function renderContent() {
        return (_jsxs("div", __assign({ className: "workflow-step-help" }, { children: [renderDescription(), renderVideo(), renderPhotos()] }), void 0));
    }
    function renderDialog() {
        return (_jsxs(Dialog, __assign({ open: true, onClose: props.onClose, className: "workflow-step-help-dialog" }, { children: [_jsx(DialogTitle, { children: props.step.title }, void 0), _jsx(DialogContent, __assign({ sx: { width: '100%', height: '100%' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: renderContent() }, void 0) }, void 0) }), void 0), _jsx(DialogActions, { children: _jsx(Button, __assign({ variant: "contained", onClick: props.onClose }, { children: "Close" }), void 0) }, void 0)] }), void 0));
    }
    if (!props.isOpen)
        return null;
    return renderDialog();
}
